import React from "react";
import {
    DashboardContainer, PayrollContainer, PendingRegistrationsContainer,
} from './styles';
import {MainLayout} from "../../layouts/MainLayout";
import Greeting from "./greeting";
import PendingEmployees from "./pendingEmployees";
import PendingPayrolls from "./pendingPayrolls";
import {FlexRowResponsive} from "../../components";

const DATA_ITEMS_PER_TABLE:number = 4

export const Dashboard = () => {
    return <MainLayout>
        <DashboardContainer>
            <FlexRowResponsive>
                <PendingRegistrationsContainer>
                    <Greeting/>
                    <PendingEmployees
                        itemsPerPage={DATA_ITEMS_PER_TABLE}
                    />
                </PendingRegistrationsContainer>
                <PayrollContainer>
                    <PendingPayrolls itemsPerPage={DATA_ITEMS_PER_TABLE}/>
                </PayrollContainer>
            </FlexRowResponsive>
        </DashboardContainer>
    </MainLayout>
}

export default Dashboard;
